import React, { useState } from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { Avatar as MuiAvatar } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import { getInitials } from 'utils/string';
import styles from './Avatar.module.css';

const Avatar = (props) => {
  const {
    children: childrenProp,
    icon: Icon,
    onError,
    src: srcProp,
    srcSet: srcSetProp,
    name,
    ...other
  } = props;
  const [isImgExist, setImgState] = useState(true);
  const src = isImgExist ? srcProp : '';
  const srcSet = isImgExist ? srcSetProp : '';

  const handleImgLoadError = () => {
    const errorFlag = onError ? onError() : undefined;

    if (errorFlag !== false) {
      setImgState(false);
    }
  };

  const renderFallbackImage = () => {
    if (Icon) {
      return <Icon />;
    }

    if (name) {
      const initials = getInitials(name);

      return initials.length === 0 ? <PersonIcon /> : initials;
    }

    return childrenProp;
  };

  return (
    <MuiAvatar
      className={styles.root}
      imgProps={{ onError: handleImgLoadError }}
      src={src}
      srcSet={srcSet}
      {...other}
    >
      {renderFallbackImage()}
    </MuiAvatar>
  );
};

Avatar.propTypes = {
  children: Type.node,
  icon: Type.elementType,
  name: Type.string,
  onError: Type.func,
  src: Type.string,
  srcSet: Type.string,
};

Avatar.defaultProps = {
  children: null,
  icon: null,
  name: '',
  src: '',
  srcSet: '',
  onError: noop,
};

export default Avatar;
